<template>
  <section id="articles">
    <Header :class="{header: true, hidden: hideHeader}"
      v-on:login="$emit('login')" :scrolled="true"/>
    <div class="loading" v-if="loading"></div>
    <div v-else class="sectionCnt">
      <div class="sectionHeader">
        <h2>Submit Pesan dan Kreasi</h2>
      </div>
      <div class="tabMenu">
        <div :class="{tabItem: true, active: tabActive === 'article'}"
          v-on:click="selectTab('article')">
          Pesan Teks
        </div>
        <div :class="{tabItem: true, active: tabActive === 'image'}"
          v-on:click="selectTab('image')">
          Visual
        </div>
        <div :class="{tabItem: true, active: tabActive === 'video'}"
          v-on:click="selectTab('video')">
          Audio Visual
        </div>
      </div>
      <div class="formCnt">
        <div :class="{fieldGroup: true, hasError: form.title.error}">
          <input type="text" class="field" placeholder="Judul Pesan dan Kreasi"
            v-model="form.title.model" v-on:input="form.title.error = null">
          <div class="fieldError" v-if="form.title.error">{{form.title.error}}</div>
        </div>
        <div class="editorCnt" v-if="tabActive === 'article'">
          <Editor ref="editor" v-model="form.content.model" :content="content"/>
        </div>
        <div class="articleCnt" v-else>
          <div class="videoOnly imagesCnt" v-if="tabActive === 'image'">
            <div class="imageItem" v-for="(img, i) in imageFiles" :key="i">
              <div class="theImg" :style="{'background-image': `url(${img.imageMd})`}">
                <div class="deleteImg" v-on:click="imageFiles.splice(i, 1)"></div>
              </div>
            </div>
            <div class="imageItem">
              <div class="selectVideo" v-on:click="addImage">
                <img src="../assets/image-black.png">
                Pilih File Foto
              </div>
            </div>
          </div>
          <div class="videoOnly" v-if="tabActive === 'video'">
            <div class="selectVideo" v-if="!videoFile" v-on:click="addVideo">
              <img src="../assets/videos-black.png">
              Pilih File Video
            </div>
            <div v-else-if="videoFile.status === 'processing'">
              <div :class="{videoCntEd: true, vidLoading: true}"></div>
              <div class="progressCnt">
                <div class="progress processing"
                  v-bind:style="{width: `${videoFile.progress}%`}"
                  v-if="videoFile.status === 'processing'">
                  <span>Processing {{videoFile.progress}}%</span>
                  <div class="bg"></div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="videoCntEd"
                v-bind:style="{backgroundImage: `url(${videoFile[`thumb${mainThumb}`]})`}">
              </div>
              <div class="progressCnt">
                <div class="progress" v-bind:style="{width: '100%'}">
                  <span>Finished Proccessing</span>
                </div>
              </div>
            </div>
          </div>

          <div class="eventCnt theThumb">
            <div class="eventSection eventSectionInfo" v-if="tabActive === 'audio'">
              <h4>Audio File</h4>
              <div class="addAudio" v-on:click="addAudio">
                <div class="aa">
                  <img src="../assets/musical-note-white.svg" class="white">
                  <img src="../assets/musical-note-blue.svg" class="blue">
                  <span v-if="!audioFile">Pilih File Audio</span>
                  <span v-else>{{audioFile.name}}</span>
                </div>
              </div>
            </div>
            <div class="eventSection eventSectionInfo"
              v-if="tabActive === 'video' && videoFile">
              <h4>Video Thumbnail</h4>
              <div class="thumbCnt">
                <div v-bind:class="{thumbItem: true, loading: videoFile.status === 'processing'
                  || !videoFile.thumb1, active: mainThumb === 1}"
                  v-on:click="mainThumb = 1">
                  <div class="theImg" v-bind:style="{backgroundImage:
                    `url(${videoFile.thumb1})`}"
                    v-if="videoFile && videoFile.thumb1"></div>
                </div>
                <div v-bind:class="{thumbItem: true, loading: videoFile.status === 'processing'
                  || !videoFile.thumb2, active: mainThumb === 2}"
                  v-on:click="mainThumb = 2">
                  <div class="theImg" v-bind:style="{backgroundImage:
                    `url(${videoFile.thumb2})`}"
                    v-if="videoFile && videoFile.thumb2"></div>
                </div>
                <div v-bind:class="{thumbItem: true, loading: videoFile.status === 'processing'
                  || !videoFile.thumb3, active: mainThumb === 3}"
                  v-on:click="mainThumb = 3">
                  <div class="theImg" v-bind:style="{backgroundImage:
                    `url(${videoFile.thumb3})`}"
                    v-if="videoFile && videoFile.thumb3"></div>
                </div>
                <div v-bind:class="{thumbItem: true, loading: videoFile.status === 'processing'
                  || !videoFile.thumb4, active: mainThumb === 4}"
                  v-on:click="mainThumb = 4">
                  <div class="theImg" v-bind:style="{backgroundImage:
                    `url(${videoFile.thumb4})`}"
                    v-if="videoFile && videoFile.thumb4"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="editorFooter">
      <div class="btnCnt">
        <button class="btnOk" v-on:click="saveNow">Kirim Pesan Kreasi</button>
      </div>
    </div>
    <MediaUploader ref="mediaUploader"/>
    <LoadingDialog ref="loadingDialog"/>
    <Confirmation ref="confirmDialog"/>
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import Header from '@/components/Header.vue';
import Editor from '@/components/Editor.vue';
import MediaUploader from '@/components/MediaUploader.vue';
import LoadingDialog from '@/components/LoadingDialog.vue';
import Confirmation from '@/components/Confirmation.vue';

export default {
  name: 'home',
  components: {
    Header,
    Editor,
    MediaUploader,
    LoadingDialog,
    Confirmation,
  },
  data() {
    return {
      loading: false,
      hideHeader: false,
      tabActive: 'article',
      editData: null,
      audioFile: null,
      videoFile: null,
      imageFiles: [],
      content: '',
      mainThumb: 1,
      form: {
        title: { model: '', error: null },
        content: { model: '' },
      },
    };
  },
  computed: {
  },
  created() {
    window.addEventListener('scroll', this.onScrolled);
    document.getElementsByTagName('BODY')[0].classList.add('editorOpen');
    this.prevScrollpos = window.pageYOffset;
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScrolled);
    document.getElementsByTagName('BODY')[0].classList.remove('editorOpen');
  },
  methods: {
    ...mapActions([
      'chMenuActive',
    ]),
    saveNow() {
      if (!this.$session.get('jwt')) {
        this.$emit('login');
        return;
      }
      const videoId = (this.videoFile) ? this.videoFile.id : null;
      const audioId = (this.audioFile) ? this.audioFile.id : null;
      const formData = {
        type: this.tabActive,
        title: this.form.title.model.trim(),
        content: this.form.content.model,
        mainThumb: this.mainThumb,
        images: this.imageFiles,
        videoId,
        audioId,
      };
      if (!formData.title || formData.title === '') {
        this.form.title.error = 'Mohon masukan judul pesan kamu.';
        return;
      }
      const tmpEl = document.createElement('DIV');
      tmpEl.innerHTML = formData.content;
      const contentText = tmpEl.textContent || tmpEl.innerText || '';
      if (formData.type === 'article') {
        if (!contentText || contentText === '') {
          this.$refs.confirmDialog.open({
            title: 'Konten Belum Di Isi',
            desc: 'Isi konten artikel untuk melanjutkan.',
            action: 'Tutup',
            hasCancel: false,
          });
          return;
        }
        const allYoutube = this.$refs.editor.$el.querySelectorAll('iframe.theMedia');
        if (allYoutube && allYoutube.length > 0) {
          formData.youtube = allYoutube[0].getAttribute('src');
        }
        this.allMedia = this.$refs.editor.$el.querySelectorAll('img.theMedia');
        if (this.allMedia && this.allMedia.length > 0) {
          formData.thumb = this.allMedia[0].getAttribute('mediaid');
        } else {
          formData.thumb = null;
        }
      } else if (formData.type === 'image') {
        if (this.imageFiles.length < 1) {
          this.$refs.confirmDialog.open({
            title: 'Belum Memilih Foto',
            desc: 'Pilih minimal 1 foto untuk melanjutkan.',
            action: 'Tutup',
            hasCancel: false,
          });
          return;
        }
      }
      this.$http.post(this.$config.uri('article/user/save'), formData).then((r) => {
        this.$router.push('/bicara-bumi/pesan-dan-kreasi');
      });
    },
    addAudio() {
      document.getElementsByTagName('BODY')[0].classList.add('selectingMedia');
      this.$refs.mediaUploader.open({
        type: 'audio',
      }, (b, m) => {
        document.getElementsByTagName('BODY')[0].classList.remove('selectingMedia');
        if (!b) return;
        this.getLastMedia((media) => {
          this.audioFile = media;
        });
      });
    },
    addVideo() {
      document.getElementsByTagName('BODY')[0].classList.add('selectingMedia');
      this.$refs.mediaUploader.open({
        type: 'video',
      }, (b, m) => {
        document.getElementsByTagName('BODY')[0].classList.remove('selectingMedia');
        if (!b) return;
        this.getLastMedia((media) => {
          this.videoFile = media;
          this.getMediaProgress(this.videoFile);
        });
      });
    },
    addImage() {
      document.getElementsByTagName('BODY')[0].classList.add('selectingMedia');
      this.$refs.mediaUploader.open({
        type: 'image',
      }, (b, m) => {
        document.getElementsByTagName('BODY')[0].classList.remove('selectingMedia');
        if (!b) return;
        this.getLastMedia((media) => {
          this.imageFiles.push(media);
        });
      });
    },
    getLastMedia(next) {
      this.$refs.loadingDialog.open();
      this.$http.get(this.$config.uri('media/user/all?limit=1')).then((r) => {
        this.$refs.loadingDialog.close();
        if (r.data.status !== 200) return;
        next(r.data.data[0]);
      });
    },
    getMediaProgress(media) {
      this.$http.get(this.$config.uri(`media/user/progress/${media.id}`)).then((r) => {
        if (r.data.status !== 200) return;
        this.videoFile.progress = r.data.data.progress;
        this.videoFile.status = r.data.data.status;
        if (r.data.data.status === 'processing') {
          setTimeout(() => {
            this.getMediaProgress(media);
          }, 5000);
        } else if (r.data.data.status === 'processed') {
          this.videoFile.thumb1 = r.data.data.thumb1;
          this.videoFile.thumb2 = r.data.data.thumb2;
          this.videoFile.thumb3 = r.data.data.thumb3;
          this.videoFile.thumb4 = r.data.data.thumb4;
        }
      });
    },
    selectTab(tab) {
      this.tabActive = tab;
    },
    viewLink(item) {
      if (item.event && item.event.url) {
        window.open(item.event.url);
      }
    },
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = 'Submit Pesan dan Kreasi - Bumi Butuh Aksi';
    if (!this.$session.get('jwt')) {
      this.$emit('login');
    }
  },
};
</script>

<style scoped lang="scss">
#articles{
  min-height: 100vh;
  background-color: #fff;
  box-sizing: border-box;
  padding-top: 80px;
}

.selectVideo{
  height: 340px;
  background-color: #eee;
  text-align: center;
  box-sizing: border-box;
  padding-top: 116px;
  font-size: 30px;
  border-radius: 5px;
  cursor: pointer;
  transition: all .3s ease;
  color: #767676;
  font-weight: 600;
  @media (max-width: 680px) {
    height: 200px;
    font-size: 20px;
    padding-top: 60px;
  }
  img{
    transition: all .3s ease;
    display: block;
    margin: 0 auto 16px;
    height: 54px;
    opacity: .4;
    @media (max-width: 680px) {
      height: 40px;
    }
  }
  &:hover{
    color: #444;
    background-color: #e5e5e5;
    img{
      opacity: .6;
    }
  }
}

.editorCnt{
  padding-bottom: 60px;
}
.articleCnt{
  padding-bottom: 80px;
}

.videoCntEd{
  width: 100%;
  height: 340px;
  background-color: #eee;
  border-radius: 5px 5px 0 0;
  background-position: center;
  background-size: cover;
  @media (max-width: 680px) {
    height: 200px;
  }
  &.vidLoading{
    background-image: url(../assets/loading-2.svg);
    background-size: 46px auto;
    background-repeat: no-repeat;
  }
}
.progressCnt{
  background-color: #ccc;
  height: 30px;
  border-radius: 0 0 5px 5px;
  overflow: hidden;
  .progress{
    height: 100%;
    background-color: #0bad00;
    color: #fff;
    white-space: nowrap;
    font-weight: bold;
    font-size: 16px;
    text-align: center;
    padding: 4px 20px;
    box-sizing: border-box;
    position: relative;
    transition: all .6s ease;
    span{
      position: relative;
      z-index: 2;
    }
    @-webkit-keyframes MOVE-BG {
      from {
        -webkit-transform: translateX(0);
      }
      to {
        -webkit-transform: translateX(46px);
      }
    }
    @keyframes MOVE-BG {
      from {
        transform: translateX(0);
      }
      to {
        transform: translateX(46px);
      }
    }
    .bg{
      position: absolute;
      left: 0; right: 0; top: 0; bottom: 0;
      overflow: hidden;
      z-index: 1;
    }
    &.processing{
      background-color: orange;
    }
    &.processing .bg:before{
      display: block;
      content: "";
      position: absolute;
      left: -46px;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 1;
      background: -webkit-repeating-linear-gradient(
        145deg,
        rgba(0,0,0,.1) 1px,
        rgba(0,0,0,0) 2px,
        rgba(0,0,0,0) 11px,
        rgba(0,0,0,.1) 12px,
        rgba(0,0,0,.1) 20px
      );
      background: repeating-linear-gradient(
        -55deg,
        rgba(0,0,0,.1) 1px,
        rgba(0,0,0,0) 2px,
        rgba(0,0,0,0) 11px,
        rgba(0,0,0,.1) 12px,
        rgba(0,0,0,.1) 20px
      );
      -webkit-animation-name: MOVE-BG;
      -webkit-animation-duration: .6s;
      -webkit-animation-timing-function: linear;
      -webkit-animation-iteration-count: infinite;
      animation-name: MOVE-BG;
      animation-duration: .6s;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
    }
  }
}
.videoOnly{
  margin-bottom: 20px;
}
.imagesCnt{
  display: flex;
  flex-wrap: wrap;
  margin: 0 -8px;
  .imageItem{
    width: 33.33333%;
    padding: 0 8px 16px;
    box-sizing: border-box;
    @media (max-width: 680px) {
      width: 50%;
    }
    .theImg{
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      height: 200px;
      border-radius: 3px;
      position: relative;
      @media (max-width: 680px) {
        height: 140px;
      }
      .deleteImg{
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background-image: url(../assets/close-bold-white.png);
        background-size: 10px auto;
        background-position: center;
        background-repeat: no-repeat;
        position: absolute;
        right: -6px; top: -6px;
        background-color: #f76292;
        cursor: pointer;
        transition: all .3s ease;
        &:hover{
          background-color: #ff135f;
          box-shadow: 2px 2px 4px rgba(0,0,0,.1);
        }
      }
    }
    .selectVideo{
      height: 200px;
      font-size: 17px;
      padding-top: 54px;
      @media (max-width: 680px) {
        height: 140px;
        padding-top: 26px;
        font-size: 14px;
      }
    }
  }
}

.editorFooter{
  position: fixed;
  left: 0; right: 0; bottom: 0;
  background-color: #fff;
  z-index: 991;
  border-top: #eee 1px solid;
  padding: 10px 0;
  .btnCnt{
    max-width: 740px;
    text-align: right;
    margin: 0 auto;
    @media (max-width: 960px) {
      max-width: none;
      margin: 0 20px;
    }
  }
  button{
    background-color: #31c1f4;
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    color: #fff;
    font-weight: 700;
    border-radius: 3px;
    cursor: pointer;
    transition: all .3s ease;
    border: none;
    font-size: 17px;
    &:hover{
      background-color: #1eb0e4;
      box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1);
    }
  }
}

.sectionCnt{
  max-width: 740px;
  margin: 0 auto;
  @media (max-width: 960px) {
    max-width: none;
    margin: 0 46px;
  }
}

.tabMenu{
  display: flex;
  border-bottom: #ccc 2px solid;
  margin-bottom: 20px;
  .tabItem{
    padding: 10px 20px;
    font-weight: 700;
    font-size: 18px;
    color: #999;
    border-bottom: #ccc 2px solid;
    margin-bottom: -2px;
    cursor: pointer;
    transition: all .3s ease;
    @media (max-width: 680px) {
      padding: 10px;
      font-size: 14px;
    }
    &:hover{
      color: #444;
      border-color: #767676;
    }
    &.active{
      color: #009b4b;
      border-color: #009b4b;
    }
  }
}
.sectionHeader{
  // border-bottom: #999 2px solid;
  position: relative;
  padding: 30px 0 6px;
  // margin-bottom: 16px;
  @media (max-width: 960px) {
    padding-top: 20px;
  }
  @media (max-width: 680px) {
    padding-top: 0;
  }
  h2{
    font-size: 46px;
    font-weight: 800;
    margin: 0;
    @media (max-width: 680px) {
      font-size: 22px;
      margin-bottom: 4px;
    }
  }
}
.tab{
  display: flex;
  margin-bottom: 30px;
  .tabItem{
    margin-right: 40px;
    text-transform: uppercase;
    font-weight: 800;
    cursor: pointer;
    font-size: 17px;
    border-bottom: transparent 3px solid;
    padding-bottom: 4px;
    &:hover{
      border-color: #ccc;
    }
    &.active{
      border-color: #009b4b;
    }
  }
}
.sectionSm{
  display: flex;
  margin: 0 -15px;
  flex-wrap: wrap;
  .sItem{
    width: 25%;
    box-sizing: border-box;
    padding: 0 15px;
    margin-bottom: 30px;
    color: #444;
    .sItemIn{}
    .sImg{
      height: 200px;
      background-color: #444;
      cursor: pointer;
    }
    .sInfo{
      padding: 10px 2px 20px;
      h4{
        margin: 0;
        font-size: 24px;
        cursor: pointer;
      }
      p{
        margin: 0;
        font-size: 16px;
        cursor: pointer;
      }
      .creator{
        font-size: 14px;
        font-weight: 600;
        margin-top: 16px;
      }
    }
  }
}
.submitPesan{
  display: inline-block;
  margin: 20px 0 80px;
  padding: 12px 20px;
  font-size: 18px;
  font-weight: 800;
  padding-left: 64px;
  position: relative;
  cursor: pointer;
  transition: all .3s ease;
  &:hover{
    background-color: #e6e8e1;
  }
  &:before{
    content: "";
    width: 40px;
    position: absolute;
    left: 10px; top: 0; bottom: 0;
    background-image: url(../assets/plus-circle.png);
    background-size: 36px auto;
    background-position: center;
    background-repeat: no-repeat;
    opacity: .8;
  }
}

.loading{
  padding-top: 80px;
  position: relative;
  overflow: hidden;
  &:before{
    content: "";
    display: block;
    position: absolute;
    top: -40px;
    bottom: -40px;
    left: -200px;
    width: 200px;
    background-image: linear-gradient(to right, transparent,#fff,transparent);
    transform: rotate(14deg);
    z-index: 2;
    animation: skAnimate 2.2s infinite;
    opacity: .8;
    @keyframes skAnimate {
      from { left: -200px; }
      to { left: calc(100% + 200px); }
    }
  }
  .loadingCnt{
    &.loadingCnt2{
      margin-top: 94px;
      padding-top: 3px;
      .ttl{
        background-color: #eee;
      }
      .lIt{
        background-color: #eee;
      }
      &.loadingCnt3{
        margin-top: 104px;
        margin-bottom: 80px;
        background-color: #fff;
        .lIt{
          height: 524px;
        }
      }
    }
    .ttl{
      height: 30px;
      background-color: #eee;
      margin-bottom: 29px;
      max-width: 200px;
      &.ttl1{
        margin-top: 39px;
      }
    }
    .lItCnt{
      display: flex;
      margin: 0 -10px;
    }
    .lIt{
      height: 295px;
      width: calc(25% - 20px);
      margin: 0 10px;
      background-color: #eee;
    }
  }
}

.thumbCnt{
  display: flex;
  margin: 0 -5px;
  .thumbItem{
    width: calc(25% - 10px);
    margin: 0 5px;
    height: 100px;
    background-color: #ccc;
    border-radius: 5px;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
    @media (max-width: 680px) {
      height: 60px;
    }
    .chImg{
      position: absolute;
      z-index: 4;
      color: #444;
      background: #fff;
      padding: 2px 8px 4px;
      border-radius: 23px;
      font-size: 14px;
      right: 10px;
      top: 10px;
      &:hover{
        box-shadow: 2px 2px 4px rgba(0,0,0,.2);
      }
    }
    &:before{
      content: "";
      display: block;
      position: absolute;
      background-color: #999;
      left: -3px; right: -3px; top: -3px; bottom: -3px;
      opacity: 0;
      transition: all .2s ease;
      border-radius: 7px;
      z-index: 1;
    }
    &:after{
      content: "";
      display: block;
      position: absolute;
      background-color: #eee;
      left: 0px; right: 0px; top: 0px; bottom: 0px;
      border-radius: 5px;
      z-index: 2;
    }
    &:hover{
      &:after{
        background-color: #e5e5e5;
      }
    }
    .theImg{
      border-radius: 5px;
      position: absolute;
      left: 0; right: 0; top: 0; bottom: 0;
      z-index: 2;
      background-position: center;
      background-size: cover;
      z-index: 3;
    }
    &.loading{
      &:after{
        background-image: url(../assets/loading-2.svg);
        background-position: center;
        background-size: 40px auto;
        background-repeat: no-repeat;
      }
    }
    &.addImage{
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      color: #767676;
      // font-weight: bold;
      // color: #0245a7;
      transition: all .2s ease;
      .ai{
        position: relative;
        z-index: 3;
        font-size: 13px;
        font-weight: 700;
      }
      img{
        display: block;
        height: 34px;
        margin: 0 auto 5px;
        opacity: .4;
      }
    }
    &:hover{
      &:before{
        background-color: #999;
        opacity: 1;
      }
      &.addImage{
        color: #444;
        img{
          opacity: .5;
        }
      }
    }
    &.active{
      &:before{
        background-color: #0e5bd2;
        opacity: 1;
      }
    }
  }
}

.addAudio{
  color: #31c1f4;
  border: #31c1f4 2px solid;
  border-radius: 5px;
  padding: 10px;
  cursor: pointer;
  font-weight: 700;
  .aa{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  img{
    height: 20px;
    float: left;
    margin-right: 8px;
  }
  img.white{
    display: none;
  }
  &:hover{
    color: #fff;
    background-color: #31c1f4;
    img.white{
      display: inline-block;
    }
    img.blue{
      display: none;
    }
  }
}

.eventCnt{
  padding-top: 10px;
  .eventSection{
    margin-bottom: 30px;
    &.eventSectionInfo{
      margin-bottom: 20px;
    }
    h4{
      margin: 0;
      font-size: 20px;
      font-weight: normal;
      margin-bottom: 10px;
    }
    .sectionSubtitle{
      margin: -6px 0 10px 0;
      color: #767676;
      font-size: 15px;
    }
    .eventInfoCnt{
      display: flex;
      margin: 0 -10px;
      .eventInfoItem{
        width: calc(50% - 20px);
        margin: 0 auto 16px;
        &.eiiFull{
          width: calc(100% - 20px);
          margin-bottom: 0;
        }
        label{
          display: block;
          text-transform: uppercase;
          font-size: 14px;
          color: #999;
          font-weight: bold;
          margin-bottom: 5px;
        }
        .labelSub{
          color: #767676;
          font-size: 14px;
          margin: -4px 0 16px;
          max-width: 400px;
        }
        .fieldHint{
          font-size: 13px;
          color: #767676;
          padding: 2px 0 0 7px;
        }
      }
    }
  }
  &.theThumb{
    padding-top: 0;
    .eventSection{
      h4{
        margin: 0;
        margin-left: 10px;
        margin-bottom: 4px;
        text-transform: uppercase;
        color: #999;
        font-weight: 800;
        font-size: 12px;
      }
    }
  }
}

</style>
